import React from "react";
import styles from "./SearchInput.module.css";
import search_icon from "assets/images/search-icon.svg";
import { AiOutlineSearch } from "react-icons/ai";

function SearchInput({ register, name, placeholder }) {
  return (
    <>
      {/* DISPLAY ON SMALL SCREENS */}
      {/* <div className={styles.mobile_search}>
        <AiOutlineSearch fontSize={"20px"} />
      </div> */}
      <div className={styles.search_box}>
        <div className={styles.search_icon}>
          <img src={search_icon} alt="search" />
        </div>
        <input {...register(name)} type="text" placeholder={placeholder} />
      </div>
    </>
  );
}

export default SearchInput;
